export const CORPORATE_THEME = {
	name: 'corporate',
	base: 'default',
	variables: {}
};
